export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/+$/, ''); // Remove trailing slashes
  }

  // In production, use the live API URL
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  // In development, fall back to localhost
  return 'http://localhost:3001/api';
};

export const getBaseUrl = () => {
  // In production, use the same origin
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  
  // In development, fall back to localhost
  return 'http://localhost:3001';
};